/**
 * Defect Status Badge Component
 * Three-state status indicator for defects: OPEN (red), UNSURE (amber), RESOLVED (green).
 *
 * Requirements: 14.5
 */

import { DEFECT_STATUS } from '../utils/constants.js';

/**
 * Get the CSS class for a defect status badge.
 * @param {string} status - OPEN, UNSURE, or RESOLVED
 * @returns {string} CSS class name
 */
export function getDefectStatusClass(status) {
  switch (status) {
    case DEFECT_STATUS.OPEN: return 'badge-red';
    case DEFECT_STATUS.UNSURE: return 'badge-amber';
    case DEFECT_STATUS.RESOLVED: return 'badge-green';
    default: return '';
  }
}

/**
 * Get the display label for a defect status.
 * @param {string} status - OPEN, UNSURE, or RESOLVED
 * @returns {string} Human-readable label
 */
export function getDefectStatusLabel(status) {
  switch (status) {
    case DEFECT_STATUS.OPEN: return 'Open';
    case DEFECT_STATUS.UNSURE: return 'Unsure';
    case DEFECT_STATUS.RESOLVED: return 'Resolved';
    default: return status || '—';
  }
}

/**
 * Render a defect status badge as an HTML string.
 * @param {string} status - OPEN, UNSURE, or RESOLVED
 * @returns {string} HTML string for the badge
 */
export function renderDefectStatusBadge(status) {
  const cls = getDefectStatusClass(status);
  const label = getDefectStatusLabel(status);
  return `<span class="badge ${cls}">${label}</span>`;
}
